import { Component } from '@angular/core';
import { header } from './config/user.config';
import { UserService } from '../../services/user/user.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss',
})
export class UserComponent {
  constructor(private userService: UserService) {}

  ngOnInit() {
    this.userService.init();
  }

  getPageHeader(): string {
    return header;
  }
}
